import { FC } from 'react'
import { createPortal } from 'react-dom'
import styles from './supportContactModal.module.scss'

interface SupportContactModalProps {
  description?: string
  isOpen: boolean
  onClose: () => void
  onContactSupport?: () => void
  title?: string
}

export const SupportContactModal: FC<SupportContactModalProps> = ({
  description = "You're here because your daily AI credit limit has been reached. Our Support team will help you continue without interruption.",
  isOpen,
  onClose,
  onContactSupport,
  title = 'Support',
}) => {
  if (!isOpen) return null

  const handleCopyPhone = () => {
    navigator.clipboard.writeText('+995 599 888 955')
  }

  const handleEmailClick = () => {
    window.location.href = 'mailto:hello@hapttic.com'
  }

  return createPortal(
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.modalContent}>
          <div className={styles.header}>
            <h2 className={styles.title}>{title}</h2>
            <button className={styles.closeButton} onClick={onClose}>
              <svg fill="none" height="24" viewBox="0 0 24 24" width="24">
                <path
                  d="M18 6L6 18M6 6L18 18"
                  stroke="#25262D"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
              </svg>
            </button>
          </div>

          <p className={styles.description}>{description}</p>

          <div className={styles.contactOptions}>
            <button className={styles.contactRow} onClick={handleEmailClick}>
              <div className={styles.contactInfo}>
                <svg
                  className={styles.contactIcon}
                  fill="none"
                  height="20"
                  viewBox="0 0 20 20"
                  width="20"
                >
                  <path
                    d="M2.49935 2.5H17.4993C17.9596 2.5 18.3327 2.8731 18.3327 3.33333V16.6667C18.3327 17.1269 17.9596 17.5 17.4993 17.5H2.49935C2.03912 17.5 1.66602 17.1269 1.66602 16.6667V3.33333C1.66602 2.8731 2.03912 2.5 2.49935 2.5ZM10.0498 9.73575L4.70537 5.19808L3.62667 6.46858L10.0603 11.9309L16.378 6.46347L15.2873 5.2032L10.0498 9.73575Z"
                    fill="#25262D"
                  />
                </svg>
                <span>hello@hapttic.com</span>
              </div>
              <svg
                className={styles.actionIcon}
                fill="none"
                height="20"
                viewBox="0 0 20 20"
                width="20"
              >
                <path
                  d="M13.337 7.84518L6.16484 15.0173L4.98633 13.8388L12.1585 6.66667H5.83701V5H15.0037V14.1667H13.337V7.84518Z"
                  fill="#25262D"
                />
              </svg>
            </button>

            <button className={styles.contactRow} onClick={handleCopyPhone}>
              <div className={styles.contactInfo}>
                <svg
                  className={styles.contactIcon}
                  fill="none"
                  height="20"
                  viewBox="0 0 20 20"
                  width="20"
                >
                  <path
                    d="M17.5 13.6833V16.6301C17.5 17.0676 17.1617 17.4306 16.7254 17.4614C16.3609 17.4872 16.0636 17.5 15.8333 17.5C8.4695 17.5 2.5 11.5305 2.5 4.16667C2.5 3.93642 2.51288 3.63906 2.53863 3.27458C2.56948 2.83823 2.93245 2.5 3.36988 2.5H6.31675C6.53065 2.5 6.7098 2.66202 6.73127 2.87483C6.75056 3.06589 6.76848 3.21928 6.78506 3.33502C6.95362 4.51227 7.29794 5.6328 7.79058 6.66919C7.86966 6.83554 7.81809 7.03466 7.66821 7.14172L5.86962 8.4265C6.9646 10.9843 9.01575 13.0354 11.5735 14.1304L12.8559 12.3349C12.9643 12.1832 13.1658 12.1311 13.3342 12.211C14.3705 12.7032 15.4909 13.0472 16.668 13.2153C16.783 13.2318 16.9354 13.2496 17.1252 13.2687C17.338 13.2902 17.5 13.4694 17.5 13.6833Z"
                    fill="#25262D"
                  />
                </svg>
                <span>+995 599 888 955</span>
              </div>
              <svg
                className={styles.actionIcon}
                fill="none"
                height="20"
                viewBox="0 0 20 20"
                width="20"
              >
                <path
                  d="M5.83317 5.00008V2.50008C5.83317 2.03985 6.20627 1.66675 6.6665 1.66675H16.6665C17.1267 1.66675 17.4998 2.03985 17.4998 2.50008V14.1667C17.4998 14.627 17.1267 15.0001 16.6665 15.0001H14.1665V17.4993C14.1665 17.96 13.7916 18.3334 13.3275 18.3334H3.33888C2.87549 18.3334 2.5 17.9629 2.5 17.4993L2.50217 5.83414C2.50225 5.37351 2.8772 5.00008 3.34118 5.00008H5.83317ZM7.49983 5.00008H14.1665V13.3334H15.8332V3.33341H7.49983V5.00008Z"
                  fill="#25262D"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className={styles.footer}>
          <button className={styles.discardButton} onClick={onClose}>
            Discard
          </button>
          <button
            className={styles.contactSupportButton}
            onClick={() => {
              if (onContactSupport) {
                onContactSupport()
              } else {
                handleEmailClick()
              }
            }}
          >
            Contact Support
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}
